// extracted by mini-css-extract-plugin
module.exports = {"layout":"changeDesksSettings_layout__lBniB"};